"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var updateSelectedPackages = function (packages) {
    return (0, service_1.getService)()
        .put('/packages/select_packages', { ids: packages })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = updateSelectedPackages;
